document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init () {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images () {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg () {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }

  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGMegaMenuTabs extends HTMLElement {
    constructor() {
      super()
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback () {
      this.$tabList = this.querySelectorAll('.yg-sub-link')
      this.$tabContentList = this.querySelectorAll('.yg-mega-menu-content')

      this.$tabList.forEach(($tabTitle, i) => {
        $tabTitle.addEventListener('mouseover', () => this.itemClick($tabTitle, i));
      })
    }

    itemClick ($tabTitle, i, $tabTitleList, $tabContentList) {
      if ($tabTitle.classList.contains('active')) {
        return
      }
      // 这里放置自定义逻辑
      this.activateTab(i, $tabTitleList, $tabContentList);
    }

    activateTab (index, $tabTitleList, $tabContentList) {
      let $tabTitleListH = ($tabTitleList && $tabContentList) ? $tabTitleList : this.$tabList
      let $tabContentListH = ($tabTitleList && $tabContentList) ? $tabContentList : this.$tabContentList

      $tabTitleListH.forEach(tab => tab.classList.remove('active'));
      $tabContentListH.forEach(content => content.classList.remove('active'));

      if ($tabTitleListH[index]) {
        $tabTitleListH[index].classList.add('active');
      }
      if ($tabContentListH[index]) {
        $tabContentListH[index].classList.add('active');
      }
    }
  }

  if (!window.customElements.get('yg-mega-menu-tabs')) {
    window.customElements.define('yg-mega-menu-tabs', YGMegaMenuTabs)
  }

  class YGMaps extends HTMLElement {
    constructor() {
      super();
      this.activeTypeTabs = this.querySelector('.yg-active-map')?.querySelectorAll('.yg-location-type');
      this.dotList = this.querySelectorAll('.yg-dot-box');
      this.bottomTabs = this.querySelector('.yg-tabs-bottom')?.querySelectorAll('.yg-location-type');
      this.defaultAddress = this.querySelector('.yg-bottom-address[data-type="corporate_headquarters"][data-index="1"]');
      this.typeClick = this.typeClick.bind(this);
      this.bottomTabClick = this.bottomTabClick.bind(this);
      this.first = true
    }
    connectedCallback () {
      const section = this.closest("section");
      if (!section) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              section.classList.add("active");
            } else {
              section.classList.remove("active");
            }
          });
        },
        {
          threshold: 0.7
        }
      );

      observer.observe(this);
      this.activeTypeTabs.forEach((type) => {
        type.addEventListener('click', (type) => this.typeClick(type));
      });
      this.bottomTabs.forEach((tab) => {
        tab.addEventListener('click', (tab) => this.bottomTabClick(tab));
      });

      if (window.screen.width < 1150) {
        this.defaultAddress?.click();
      }
    }
    disconnectedCallback () {
      this.activeTypeTabs.forEach((type) => {
        type.removeEventListener('click', (type) => this.typeClick(type));
      });
      this.bottomTabs.forEach((tab) => {
        tab.removeEventListener('click', (tab) => this.bottomTabClick(tab));
      });
    }
    typeClick (type) {
      // 这里放置自定义逻辑
      if (!type) return;
      const $type = type.target.closest('.yg-location-type');
      const typeID = $type.getAttribute('data-type');
      const $dotList = Array.from(this.dotList).filter((dot) => dot.getAttribute('data-type') == typeID);

      if ($type.classList.contains('active')) {
        $type.classList.remove('active');
        $dotList.forEach((dot) => dot.classList.remove('active'));
      } else {
        $type.classList.add('active');
        $dotList.forEach((dot) => dot.classList.add('active'));
      }
    }

    bottomTabClick (tab) {
      const $tab = tab.target.closest('.yg-location-type');
      if (!$tab || !tab) return;

      const $tabTitle = tab.target.closest('.yg-acc-title');
      const $address = tab.target.closest('.yg-bottom-address');
      if ($tabTitle) {
        if ($tab.classList.contains('active')) {
          return;
        } else {
          let height = 0;
          this.bottomTabs.forEach((tab) => {
            tab.classList.remove('active');
            tab.querySelector('.yg-acc-content').style.height = 0;
          });
          let content = $tab.querySelector('.yg-acc-content');
          content.style.height = 'auto';
          height = content.getBoundingClientRect().height + 12;
          content.style.height = 0;
          content.getBoundingClientRect();
          content.style.height = `${height}px`;
          $tab.classList.add('active');
        }
      }

      if ($address) {
        let $dot = this.querySelector(
          `.yg-dot-box[data-type="${$address.getAttribute('data-type')}"][data-index="${$address.getAttribute(
            'data-index'
          )}"]`
        );
        const container = this.querySelector('.yg-maps'); // 替换为你的容器选择器

        if ($dot && container) {
          const targetRect = $dot.querySelector('.dot-item').getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();

          // 计算 target 相对 container 的 top、left 距离
          const offsetTop = targetRect.top - containerRect.top + container.scrollTop;
          const offsetLeft = targetRect.left - containerRect.left + container.scrollLeft;

          // 计算居中位置
          const scrollTop = offsetTop - container.clientHeight / 2 + targetRect.height / 2;
          const scrollLeft = offsetLeft - container.clientWidth / 2 + targetRect.width / 2;

          if (!this.first) {
            const top = container.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({
              behavior: 'smooth',
              top: top
            });
          }

          container.scrollTo({
            top: scrollTop,
            left: scrollLeft,
            behavior: 'smooth',
          });

          this.first = false
        }
      }
    }
  }
  if (!window.customElements.get('yg-maps')) {
    window.customElements.define('yg-maps', YGMaps);
  }
  class YGDot extends YGMaps {
    constructor() {
      super();
    }
    connectedCallback () {
      this.calcLine();
      window.addEventListener('resize', () => this.calcLine());
    }

    calcLine () {
      const p1 = this.querySelector('.dot-item').getBoundingClientRect();
      const p2 = this.querySelector('.yg-dot-info').getBoundingClientRect();

      const svg = this.querySelector('.lineSvg');
      const rect = svg?.getBoundingClientRect();

      if (!p1 || !p2 || !svg) {
        return;
      }

      // 计算中心点
      const x1 = p1.left + p1.width / 2 - rect.left;
      const y1 = p1.top + p1.height / 2 - rect.top;
      const x2 = p2.left + p2.width / 2 - rect.left;
      const y2 = p2.top + p2.height / 2 - rect.top;

      const line = svg.querySelector('.line');
      line.setAttribute('x1', x1);
      line.setAttribute('y1', y1);
      line.setAttribute('x2', x2);
      line.setAttribute('y2', y2);
    }
  }
  if (!window.customElements.get('yg-dot')) {
    window.customElements.define('yg-dot', YGDot);
  }
  class DynamicItem extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback () {
      this.classList.add("fade-in-on-scroll");

      const options = {
        threshold: 0.3
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add("yg-animated");
            this.observer.unobserve(this);
          }
        });
      }, options);

      this.observer.observe(this);
    }

    disconnectedCallback () {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get("yg-animation-item")) {
    customElements.define("yg-animation-item", DynamicItem);
  }


  const onYouTubePromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = () => resolve();
  });

  class YGDeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes () {
      return ['playing'];
    }

    connectedCallback () {
      this.bindPosterButton();

      this.addEventListener('click', (e) => {
        const video = this.querySelector('video')
        if (
          video &&
          e.target === video &&
          !video.hasAttribute('controls')
        ) {
          e.preventDefault()
          e.stopPropagation()
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      });

      if (this.autoplay) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
            }
          });
        });
        this.inViewObserver.observe(this);
      }
    }

    get posterElement () {
      return this.querySelector('[id^="YG-DeferredPoster-"]');
    }

    get autoplay () {
      return this.hasAttribute('autoplay');
    }

    get playing () {
      return this.hasAttribute('playing');
    }

    get player () {
      return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.playerHandler(target, prop);
          };
        }
      });
    }

    bindPosterButton () {
      const poster = this.posterElement;
      if (poster && !poster.hasListener) {
        poster.addEventListener('click', this.onPosterClick.bind(this));
        poster.hasListener = true;
      }
    }

    async playerTarget () {
      const template = this.querySelector('template');
      if (!template) return Promise.resolve(null);

      if (!this.mediaElement) {
        const fragment = template.content.cloneNode(true);
        this.appendChild(fragment);
        this.mediaElement = this.querySelector('video, iframe');
      }

      this.bindPosterButton();
      return Promise.resolve(this.mediaElement);
    }

    playerHandler (target, prop) {
      if (!target) return;

      if (prop === 'play' && typeof target.play === 'function') {
        target.play();
        this.setAttribute('playing', '');
        this.removeAttribute('paused');
      }

      if (prop === 'pause' && typeof target.pause === 'function') {
        target.pause();
        this.removeAttribute('playing');
        this.setAttribute('paused', '');
      }
    }

    onPosterClick (event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }

    init () {
      if (!this.paused) {
        this.play();
      }
      return () => this.pause();
    }

    play () {
      if (!this.playing) {
        this.player.play();
      }
    }

    pause () {
      if (this.playing) {
        this.player.pause();
      }
    }

    attributeChangedCallback (name, oldValue, newValue) {
      if (name === 'playing') {
        if (oldValue === null && newValue === '') {
          this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
          this.removeAttribute('paused');
        }
        if (newValue === null) {
          this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
          this.setAttribute('paused', '');
        }
      }
    }
  }

  class YGMedia extends YGDeferredMedia {
    constructor() {
      super();
    }

    connectedCallback () {
      super.connectedCallback(); // 保留父类逻辑

      if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
        this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMediaOnly();
              this.inViewObserverNoAutoplay.disconnect();
            }
          });
        });
        this.inViewObserverNoAutoplay.observe(this);
      }
    }

    async loadMediaOnly () {
      if (!this.mediaElement) {
        const template = this.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
          this.bindPosterButton();
        }
      }
    }

    async playerTarget () {
      if (this.hasAttribute('host')) {
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        return new Promise(async (resolve) => {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.bindPosterButton();

          const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
          const host = this.getAttribute('host');

          if (host === 'youtube') {
            if (!window.YT || !window.YT.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.onload = res;
                document.head.appendChild(script);
              });
              await new Promise(res => {
                window.onYouTubeIframeAPIReady = res;
              });
            }

            const player = new YT.Player(this.querySelector('iframe'), {
              events: {
                onReady: () => {
                  if (muteVideo) player.mute();
                  resolve(player);
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    this.setAttribute('playing', '');
                    this.removeAttribute('paused');
                  }
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    this.removeAttribute('playing');
                    this.setAttribute('paused', '');
                  }
                }
              }
            });
          }

          if (host === 'vimeo') {
            if (!window.Vimeo || !window.Vimeo.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = res;
                document.head.appendChild(script);
              });
            }

            const player = new Vimeo.Player(this.querySelector('iframe'));
            if (muteVideo) await player.setMuted(true);

            player.on('play', () => {
              this.setAttribute('playing', '');
              this.removeAttribute('paused');
            });
            player.on('pause', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });
            player.on('ended', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });

            resolve(player);
          }

          if (host === 'pimmedia') {
            // 假设 pimmedia 的 iframe 已经在页面上
            const iframe = this.querySelector('iframe');
            console.log("第三季我")
            if (!iframe) {
              console.warn('pimmedia iframe not found');
              return;
            }

            // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
            if (muteVideo) {
              // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
              iframe.contentWindow.postMessage({ action: 'mute' }, '*');
            }

            // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
            window.addEventListener('message', (event) => {
              // 确认是 pimmedia 的消息，可根据 event.origin 做验证
              const data = event.data;

              if (typeof data !== 'object' || !data.event) return;

              if (data.event === 'play') {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              }
              if (data.event === 'pause' || data.event === 'ended') {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              }
            });

            // 返回一个模拟的 player 对象给 resolve
            resolve({
              play () {
                iframe.contentWindow.postMessage({ action: 'play' }, '*');
              },
              pause () {
                iframe.contentWindow.postMessage({ action: 'pause' }, '*');
              },
              mute () {
                iframe.contentWindow.postMessage({ action: 'mute' }, '*');
              }
            });
          }
        });
      } else {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        const player = this.querySelector('video');
        player.addEventListener('play', () => {
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
          this.removeAttribute('suspended');
        });
        player.addEventListener('pause', () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        });

        this.bindPosterButton();
        return player;
      }
    }

    playerHandler (target, prop) {
      const host = this.getAttribute('host');

      if (host === 'youtube') {
        if (prop === 'play') {
          target.playVideo();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pauseVideo();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else if (host === 'vimeo') {
        if (prop === 'play') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else {
        if (prop === 'play') {
          target.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.setAttribute('suspended', '');
              target.controls = true;
              const replacementImageSrc = target.previousElementSibling?.currentSrc;
              if (replacementImageSrc) {
                target.poster = replacementImageSrc;
              }
            }
          });
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
    }
  }

  if (!customElements.get('yg-video')) {
    customElements.define('yg-video', YGMedia);
  }

  // 按钮动画组件
  // class YGButtonAnimation extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.hoverInTimeline = null;
  //     this.hoverOutTimeline = null;
  //     this.init();
  //   }

  //   get spanX () {
  //     return this.getAttribute('data-span-x') || 0;
  //   }

  //   get svgXStart () {
  //     return this.getAttribute('data-svg-x-start') || 0;
  //   }

  //   get svgXEnd () {
  //     return this.getAttribute('data-svg-x-end') || 0;
  //   }

  //   init () {
  //     const span = this.querySelector('.yg-button-animation-text');
  //     const svg = this.querySelector('.yg-button-animation-icon');

  //     if (!span || !svg) {
  //       console.warn('YGButtonAnimation: span 或 svg 元素未找到');
  //       return;
  //     }

  //     this.hoverInTimeline = gsap.timeline({ paused: true });
  //     this.hoverOutTimeline = gsap.timeline({ paused: true });

  //     this.hoverInTimeline
  //       .to(span, { x: this.spanX, duration: 0.3, ease: 'power2.out' }, 0)
  //       .to(svg, { x: this.svgXStart, duration: 0.2, ease: 'power2.out' }, 0)
  //       .to(svg, { x: this.svgXEnd, duration: 0.1, ease: 'power2.out' });

  //     this.hoverOutTimeline
  //       .to(span, { x: 0, duration: 0.3, ease: 'power2.out' }, 0.1)
  //       .to(svg, { x: this.svgXStart, duration: 0.1, ease: 'power2.out' }, 0)
  //       .to(svg, { x: 0, duration: 0.2, ease: 'power2.out' }, 0.1);

  //     this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
  //     this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  //   }

  //   handleMouseEnter () {
  //     if (window.innerWidth < 1024) return; // 小于1024px时直接跳过
  //     if (this.hoverOutTimeline) this.hoverOutTimeline.pause();
  //     if (this.hoverInTimeline) this.hoverInTimeline.restart();
  //   }

  //   handleMouseLeave () {
  //     if (window.innerWidth < 1024) return; // 小于1024px时直接跳过
  //     if (this.hoverInTimeline) this.hoverInTimeline.pause();
  //     if (this.hoverOutTimeline) this.hoverOutTimeline.restart();
  //   }

  //   disconnectedCallback () {
  //     if (this.hoverInTimeline) this.hoverInTimeline.kill();
  //     if (this.hoverOutTimeline) this.hoverOutTimeline.kill();
  //   }
  // }

  // if (!window.customElements.get('yg-button-animation')) {
  //   window.customElements.define('yg-button-animation', YGButtonAnimation);
  // }

  class YGSwitchImage extends HTMLElement {
    constructor() {
      super();
      this.$textList = this.textList;
      this.$imgList = this.imgList;
      this.$activeItem = this.activeItem
    }
    connectedCallback () {

      this.$textList.forEach(($item, i) => {
        $item.addEventListener('mouseenter', () => this.handHover($item, i))
      })
    }
    disconnectedCallback () {

    }
    get textList () {
      if (!this.$textList) {
        this.$textList = this.querySelectorAll('.yg-list-item');
      }
      return this.$textList;
    }
    get imgList () {
      if (!this.$imgList) {
        this.$imgList = this.querySelectorAll('.yg-img-item');
      }
      return this.$imgList;
    }
    get activeItem () {
      if (!this.$activeItem) {
        this.$activeItem = this.querySelector('.yg-list-item.active');
      }
      return this.$activeItem;
    }
    handHover (e, i) {
      this.$textList.forEach(item => item.classList.remove('active'))
      this.$imgList.forEach(item => item.classList.remove('active'))
      this.$imgList.forEach(item => item.classList.add('none'))
      this.$textList[i].classList.add('active')
      
      this.$imgList[i].classList.add('active')
  
    }
    // handleMouseLeave (e, i) {
    //   console.log("鼠标移出")

    //   this.$activeItem.classList.remove('active');
    //   this.$activeItem.classList.add('none');
    //   this.$imgList[0].classList.remove('none')
    //   this.$imgList[0].classList.add('active')
    //   this.$textList[0].classList.add('active')
    // }

    
  }

  if (!customElements.get('yg-switch-image')) {
    customElements.define('yg-switch-image', YGSwitchImage);
  }
  class YGSwiper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback () {
      this.getAllAttributes();
      this.initSwiper();
      let isAnimating = false;
      let mouseEnterTimeout;

      if (this['mousescroll']) {
        // 鼠标移入事件
        this.addEventListener('mouseenter', () => {


          // 清除可能存在的超时
          clearTimeout(mouseEnterTimeout);

          // 设置超时以避免快速鼠标进出导致的闪烁
          mouseEnterTimeout = setTimeout(() => {

            // 计算到最后一页需要滑动的次数
            const totalSlides = this.swiper.slides.length;
            const currentIndex = this.swiper.realIndex; // 使用realIndex获取真实索引（考虑loop模式）
            let slidesToScroll;

            if (currentIndex === totalSlides - 1) {
              // 如果已经在最后一页，不需要滚动
              return;
            } else {
              slidesToScroll = totalSlides - 1 - currentIndex;
            }
            // 平滑滚动到最后一张
            this.swiper.slideTo(totalSlides - 1, slidesToScroll * 300, false);
          }, 300);
        });
        // 鼠标移出事件
        this.addEventListener('mouseleave', () => {

          // 清除移入超时
          clearTimeout(mouseEnterTimeout);

          // 计算回到第一页需要滑动的次数
          const currentIndex = this.swiper.realIndex;
          let slidesToScroll;

          if (currentIndex === 0) {
            // 如果已经在第一页，不需要滚动
            return;
          } else {
            slidesToScroll = currentIndex;
          }

          this.swiper.slideTo(0, slidesToScroll * 300, false);
        });

      }
      // if (flase) {
      //   document.addEventListener('mousemove', (event) => {
      //     const element = this.querySelector('.cursor');
      //     element.style.position = 'fixed';
      //     element.style.left = `${event.clientX + 10}px`; // +10 避免遮挡光标
      //     element.style.top = `${event.clientY + 10}px`;
      //   });

      // }

    }
    get getCurrentSlidesPerView () {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints'])
        .map(Number)
        .sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes () {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides', 'mousewheel', 'mousescroll'];
      let jsonAttrs = ['breakpoints'];
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints (str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space,
        };
      }

      return result;
    }

    initSwiper () {
      const swiperConfig = {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay']
          ? {
            delay: this['autoplay'],
            stopOnLastSlide: false,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
          : false,
        pagination: this['pagination']
          ? {
            el: '.swiper-pagination',
            clickable: true,
          }
          : false,
        navigation: this['navigation']
          ? {
            nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
            prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
          }
          : false,
        scrollbar: this['scrollbar']
          ? {
            el: '.swiper-scrollbar',
            hide: true,
          }
          : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        mousewheel: this['mousewheel'] ? true : false,



        on: {
          init: (e) => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  });
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  });
                }, 250);
              }
            }


          },
        },

      }
      if (this['mousescroll']) {
        swiperConfig.speed = 800;
        swiperConfig.effect = 'slide';
        swiperConfig.allowTouchMove = false;
      }

      const swiper = new Swiper(this, swiperConfig);
      this.swiper = swiper
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper);
  }
})

